export default function($scope, $stateParams, Restangular, $locale, $location, $window) {
    var groupTherayService = Restangular.one('group_therapies', $stateParams.id);
    groupTherayService.get().then(function(therapy) {
        $scope.therapy = therapy.data || therapy;
        $scope.group = Restangular
            .one('groups', $scope.therapy.group_id)
            .get()
            .$object;
        $scope.events = groupTherayService.all('events')
            .getList({direction: 'asc', sort_by: 'start_time'}).$object;
    });
}



// WEBPACK FOOTER //
// ./js/therapy/therapy.js